var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { kmlFlyover } from "./utils/kmlFlyover";
import { defaultRendererConfig } from "./index";
// TODO: Outstanding issue with ACAD-V160671L-CI-1100-1700.kml destroys fp precision due to random line coordinates at
//       Null Island
const KML_FILES = [
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/2 Davis Road - MD & Site Plan - bing.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/3 Richardson Pl - B1 - Gnd Lvl - SVY- AUTOCAD.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/61b93b98367cd4004d93a13b-Project 5 - Site Plan.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/6188a0194340b6004c264160-Project 1 - F & L Issue.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/80215di-003a.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/147224-SS01.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/302818-U-REV-0_new (1).kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/302818-U-REV-0_new.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/303137-002-U-REV-0.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/303137-AA.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/303137-BA.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/ACAD-V160671L-CI-1100-1700.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/ACAD-V160671L-CI-1100-1700_fixed.kml",
    919520,
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/CBP - Estate Plan - Rev C.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/kml_layer.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/M8 Alignments.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/M8 Alignments_WB.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/Mentone - 54 - 76 Southern Road.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/Port Melbourne - 80 Turner St - CAD - July 2014.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/Sample - F & L Issue 2 (2).kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/Sample - F & L Issue 2.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/Smithfield - 149 McCredie Rd - Site Plan - AutoCad_recover.kml",
    "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/kml/Warringah Freeway_Sample.kml",
];
export function kmlFlyovers(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        for (let i = 0; i < KML_FILES.length; i += 1) {
            const file = KML_FILES[i];
            description.innerHTML =
                "<h1>" +
                    `KML Flyover ${i + 1}` +
                    "</h1>" +
                    "<p>" +
                    "The camera will be looking at a KML object. It should render normally." +
                    "</p>";
            if (typeof file === "number") {
                yield kmlFlyover(defaultRendererConfig(container), {
                    type: "cesium",
                    assetId: file,
                });
            }
            else {
                yield kmlFlyover(defaultRendererConfig(container), {
                    type: "direct",
                    url: file,
                });
            }
        }
    });
}
